import Paginator from '@services/Utilities/Paginator';
import {
  getPromise,
  postPromise,
  patchPromise,
  putPromise,
  deletePromise,
} from '@services/Promise';

export default class extends Paginator {
  fetching = false;
  fetched = false;
  submitting = false;
  constructor(pagination = {}) {
    super(pagination);
  }

  getPromise(url) {
    let self = this;
    self.fetching = true;
    return getPromise(url).finally(() => {
      self.fetching = false;
      self.fetched = true;
    });
  }

  postPromise(url, data) {
    let self = this;
    self.submitting = true;
    return postPromise(url, data).finally(() => {
      self.submitting = false;
    });
  }

  patchPromise(url, data) {
    let self = this;
    self.submitting = true;
    return patchPromise(url, data).finally(() => {
      self.submitting = false;
    });
  }

  putPromise(url, data) {
    let self = this;
    self.submitting = true;
    return putPromise(url, data).finally(() => {
      self.submitting = false;
    });
  }

  deletePromise(url, data) {
    let self = this;
    self.submitting = true;
    return deletePromise(url, data).finally(() => {
      self.submitting = false;
    });
  }

  static only(...fields) {
    if (!this.data || typeof this.data !== 'function') {
      throw new Error('No data method has been specified for this modal');
    }
    let data = this.data();
    let newData = {};
    fields.forEach((field) => {
      newData[field] = data[field] || '';
    });
    return newData;
  }

  static except(...fields) {
    if (!this.data || typeof this.data !== 'function') {
      throw new Error('No data method has been specified for this modal');
    }
    let data = this.data();
    fields.forEach((field) => {
      delete data[field];
    });
    return data;
  }
}
